module.exports = __webpack_public_path__ + "static/media/sample_survey4.d7624a94.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/sample_survey4.csv
// module id = 968
// module chunks = 0